(function () {
  // ---------- commerce data ----------
  // Shopify renders #ozzi-catalog server-side from Liquid. No fetch, no token, no loading flash:
  // the data is in the HTML before this script runs. The preview has no Liquid, so it falls back
  // to a snapshot. Art stays local: it's curated, not commerce.
  //
  // LAYOUT (2026-10-04, Brandon): pick a bundle, then pick the flavours. Three cards (1, 2, 3 bags);
  // the selected card opens to one flavour dropdown per bag, the others stay one line. It replaced
  // the stepper builder (a +/- row per flavour, tier cards underneath, a subscribe checkbox), which
  // is archived at git tag builder-stepper-2026-10-04 and in builder-src/archive/. The cart engine
  // underneath (one batched write at a button, the free-item settling) is unchanged.
  //
  // CHECKOUT (2026-10-11, Brandon): both buttons go straight to checkout. They used to open the
  // cart drawer. See addToCart() and snippets/ozzi-checkout.liquid.

  var ART = {
    45944714887367: { name: "Watermelon Strawberry",  tag: null },
    45944714952903: { name: "Peach Elderflower",      tag: "Bestseller" },
    45944777998535: { name: "Cherry Limeade",         tag: null },
    45944714920135: { name: "Lychee",                 tag: null },
    45944714854599: { name: "Grape",                  tag: null },
    46177427226823: { name: "Crave Crusher Capsules", tag: null, caps: true },
    // Pre-order twins (see PREORDER below). Same name as the flavour; twinOf points at the original.
    68012391923911: { name: "Watermelon Strawberry",  tag: null, twinOf: 45944714887367 },
    68012391956679: { name: "Cherry Limeade",         tag: null, twinOf: 45944777998535 }
  };
  var CAP_ID = 46177427226823;
  // Order the flavours are offered in (sold-out ones sink to the bottom at render time).
  var DRINK_IDS = [45944714887367, 45944714952903, 45944714854599, 45944777998535, 45944714920135];

  // What the bags default to, in order: Peach, then Grape, then every other in-stock flavour before
  // any repeats, so a bigger bundle starts as a variety box. Unavailable flavours are skipped rather
  // than offered, so a sell-out degrades to a different default instead of an un-buyable one.
  var SEED_IDS = [45944714952903, 45944714854599];        // Peach Elderflower + Grape

  // Shown on sold-out flavours. One date covers all of them; if they ever come back on different
  // days this wants to become a per-variant field in ART.
  var RESTOCK_TEXT = "Restocking December 1st";

  // ---------- pre-order ----------
  // PRE-ORDER (2026-10-23, Brandon): Watermelon Strawberry and Cherry Limeade are sold out, and the
  // stock left is kept for subscribers and samples. Each has a pre-order twin in Shopify: its own
  // variant and SKU ("-PRE-ORDER"), sold at zero stock, named "(Pre-Order, Ships Dec 1)". The
  // warehouse ships the rest of an order straight away and holds the pre-order bag until the new
  // batch lands. While the regular flavour is sold out and its twin can be bought, the menu offers
  // the twin under the flavour's name, marked pre-order. The day the regular one is back in stock
  // it takes the slot again and the twin drops out of the menu on its own. A twin never goes into a
  // default box: nobody gets a pre-order bag they did not pick.
  // HAND-MIRRORED STATE: variant ids from Shopify; the date is also in the variant names there.
  var PREORDER = {
    45944714887367: 68012391923911,   // Watermelon Strawberry -> Watermelon Strawberry (Pre-Order, Ships Dec 1)
    45944777998535: 68012391956679    // Cherry Limeade        -> Cherry Limeade (Pre-Order, Ships Dec 1)
  };
  var TWIN_IDS = Object.keys(PREORDER).map(function (k) { return PREORDER[k]; });
  var PREORDER_SHIP = "December 1st";   // the expected ship date, spoken in full
  function isTwin(id) { return !!(ART[id] && ART[id].twinOf); }

  // ---------- back-in-stock waitlist ----------
  // Klaviyo's PUBLIC company id. Not a secret: Klaviyo's own onsite script already exposes it on
  // every page of this store, and /client/subscriptions/ is built for exactly this: browser-side
  // signup with no private key anywhere near the storefront.
  var KLAVIYO_COMPANY = "WJ3tpC";

  // HAND-MIRRORED STATE, like perBagOff and the sample variant ids. One Klaviyo list per flavour,
  // keyed by variant id. A flavour with no id here renders NO waitlist button at all rather than a
  // button that collects an email and drops it, so a missing id fails visibly-absent, never
  // silently-broken. Fill these in from Klaviyo (Lists & Segments -> the list -> the id in the URL).
  var WAITLIST = {
    45944714887367: "SAiAcK",   // Watermelon Strawberry -> "Back in Stock - Watermelon Strawberry"
    45944777998535: "XXAeJc"    // Cherry Limeade        -> "Back in Stock - Cherry Limeade"
  };
  function waitlistFor(id) { return WAITLIST[id] || null; }
  function joinedKey(id) { return "ozzi_wait_" + id; }
  function alreadyJoined(id) {
    try { return localStorage.getItem(joinedKey(id)) === "1"; } catch (e) { return false; }
  }
  function markJoined(id) {
    try { localStorage.setItem(joinedKey(id), "1"); } catch (e) {}
  }

  // Subscribes one email to one flavour's list. Shape verified against the live endpoint: an
  // otherwise-identical request with a bogus list id came back 400 "List not found" pointing at
  // /data/relationships/list, so everything except the id was already accepted.
  function joinWaitlist(listId, email, flavour) {
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2024-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Back in stock waitlist - " + flavour,
            profile: { data: { type: "profile", attributes: { email: email } } }
          },
          relationships: { list: { data: { type: "list", id: listId } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      return r.text().then(function (t) { throw new Error("Klaviyo " + r.status + ": " + t.slice(0, 200)); });
    });
  }
  var BOX_KEY = "ozzi_box";

  // ---------- free sample pack ----------
  // Shopify's SAMPLE code is a Buy-X-Get-Y: buy 1 Crave Crusher v2 or Capsules, get 1 Ozzi Sample
  // Packs at 100% off. A BXGY only discounts a line that is ALREADY in the cart, so the builder has
  // to put the sample there and let Shopify zero it. We then verify the line really came back free
  // and pull it straight back out if it didn't, so nobody is ever charged for a "free" sample.
  // The sample is also removed the moment the box empties: a sample-only order kills AOV and those
  // buyers don't get enough product to retain.
  var SAMPLE_ID = 45288442331335;
  var SAMPLE_CODE = "SAMPLE";
  var SAMPLE_STICKS = 5;
  // What the pack is worth. Overridden by the catalog when Liquid can see the product, so a price
  // change in Shopify carries through; this is only the fallback (it has already moved 15 -> 20).
  var SAMPLE_VALUE = 20;
  // Sample-lander offer: $10 toward the next order per bag bought, capped at 10 bags ($100).
  // Display only. The builder promises it, issuing the credit happens downstream, so the
  // credit issued downstream must honour up to $100 to match what this shows.
  var CREDIT_PER_UNIT = 10;
  var CREDIT_MAX_UNITS = 10;
  function secondOrderCredit(n) { return Math.min(n, CREDIT_MAX_UNITS) * CREDIT_PER_UNIT; }
  // Opt in per embed: <div id="ozzi-builder" data-sample="true">, OR site-wide for anyone in the
  // samples A/B arm. The cohort cookie (ozzi_offer=samples) is set on /pages/ozzi-s and follows the
  // visitor everywhere, so the free pack they were promised is honoured on any builder page, not
  // just the sample lander. The SAMPLE_ON branch in init then forces mode "standard", so the
  // auto-applied SAMPLE never fights a page's CRUSH15 code on the session.
  // Non-cohort visitors are unaffected: no cookie, no data-sample -> SAMPLE_ON stays false.
  //
  // PAUSED 2026-09-29 (Brandon): sample inventory is low, so the free pack comes off every builder
  // and the sample landers pass CRUSH15 instead. This one switch covers all three ways into the
  // offer: data-sample, the scratch A/B, and the ozzi_offer=samples cookie that follows a past
  // lander visitor for 90 days. Everything below is left intact; true restores the cart mechanics
  // as they were. The gift row and scratch panel have NOT been looked at in the bundle-card layout
  // (2026-10-04), so check them on a draft before turning this back on.
  var SAMPLE_OFFER_LIVE = false;
  var SAMPLE_ON = SAMPLE_OFFER_LIVE && (function () {
    var m = document.getElementById("ozzi-builder");
    if (m && m.dataset.sample && m.dataset.sample !== "false") return true;
    if (m && m.dataset.gift === "scratch") return true;   // the scratch gift IS the sample pack
    return /(?:^|;\s*)ozzi_offer=samples(?:;|$)/.test(document.cookie);
  })();
  // How the free pack is presented. "scratch" is the A/B variant: same pack, same cart mechanics,
  // discovered by scratching instead of just being listed. Opt in per embed with
  // <div id="ozzi-builder" data-gift="scratch">.
  var GIFT_MODE = (function () {
    var m = document.getElementById("ozzi-builder");
    return SAMPLE_OFFER_LIVE && m && m.dataset.gift === "scratch" ? "scratch" : "plain";
  })();

  // ---------- promo: buy 2 bags, get a bottle of Capsules free ----------
  // ENDED 2026-10-05 00:00 Central. Left in place because the cart half still matters after the
  // end (a bottle left in a cart from before midnight is pulled out, never billed) and because the
  // next promo of this shape is a change of dates, not a rebuild.
  //
  // The free bottle is its OWN product, "Crave Crusher Capsules (Free Gift)" (unlisted, same SKU as
  // the real bottle so the warehouse ships the same thing). It is deliberately not the regular
  // capsules product: that one is in the bundle discounts, so a free regular bottle would count as
  // an item and move 2 bags onto the 3-item price.
  //
  // Shopify's side is an automatic "amount off products" discount, "Buy 2 bags, get Capsules free":
  // $55 off the Free Gift product, once per order. It has NO bag condition. The 2-bag rule lives
  // here: settleCart() only ever puts the bottle in a cart with 2+ bags and takes it out below that.
  // A Buy X Get Y was tried first and does not work with this store's bundle pricing (tested live
  // 2026-09-29): Shopify ties a BXGY to the two bags that earn it, a line carries one product
  // discount, so the bags lost their bundle tier at 2 and the bottle was charged at 3+.
  //
  // The bottle is its own line, marked with a hidden "_gift" property, so it never merges with
  // anything and the builder never counts it as a picked item. Nobody is billed for it: if it comes
  // back priced it is pulled straight back out and the promo is hidden for the visit (settleCart).
  //
  // HAND-MIRRORED STATE, like perBagOff: start and end must match the discount's dates in Shopify
  // admin, and the discount's $55 must equal the Free Gift product's price. Timestamps carry their
  // offset, so the switch-over is the same instant for every visitor.
  var PROMO = {
    start: Date.parse("2026-09-30T00:00:00-05:00"),   // Wednesday Sep 30, 12:00 AM Central (CDT)
    end: Date.parse("2026-10-05T00:00:00-05:00"),     // end of Sunday Oct 4, Central (the email: Wednesday through Sunday)
    buyBags: 2,
    drinkProduct: 8571708604615,                      // Crave Crusher: every flavour counts as a bag
    prop: "_gift",
    propValue: "Buy 2 bags, get Capsules free"
  };
  // Outside the dates, for QA and the draft theme preview (remembered for the tab; ?oz_promo=0
  // clears it):
  //   ?oz_promo=1     shows the promo. Display only, the cart is never touched.
  //   ?oz_promo=cart  also adds the bottle. With the $55 discount not live the bottle comes back
  //                   priced and is pulled out (the refusal path); to see it free, put a CODE copy
  //                   of the discount on the session with /discount/<code>.
  // Neither can give anything away: a bottle Shopify does not zero is pulled straight back out.
  // Any oz_promo value also clears an earlier refusal (below), so a QA pass can start over.
  // A bottle Shopify refused to zero switches the promo off for this browser session, so a cart
  // that does not qualify is not re-tried (and re-refused) on every page load.
  var GIFT_REFUSED_KEY = "ozzi_gift_refused";
  var PROMO_PREVIEW = (function () {
    var m = /[?&]oz_promo=(1|0|cart)(?:&|$)/.exec(location.search);
    try {
      if (m) sessionStorage.removeItem(GIFT_REFUSED_KEY);
      if (m && m[1] !== "0") sessionStorage.setItem("ozzi_promo_preview", m[1]);
      if (m && m[1] === "0") sessionStorage.removeItem("ozzi_promo_preview");
      return sessionStorage.getItem("ozzi_promo_preview") || "";
    } catch (e) { return (m && m[1] !== "0") ? m[1] : ""; }
  })();
  function giftRefused() {
    try { return sessionStorage.getItem(GIFT_REFUSED_KEY) === "1"; } catch (e) { return !!state.giftRefused; }
  }
  function refuseGift() {
    state.giftRefused = true;
    try { sessionStorage.setItem(GIFT_REFUSED_KEY, "1"); } catch (e) {}
  }
  function promoWindow() {
    var now = Date.now();
    return now >= PROMO.start && (!PROMO.end || now < PROMO.end);
  }
  // Shown: the builder advertises it. Cart: the builder adds the bottle.
  function promoShown() {
    return !!(GIFT && GIFT.available) && !state.giftRefused && !giftRefused() && (!!PROMO_PREVIEW || promoWindow());
  }
  function promoCart() {
    return !!(GIFT && GIFT.available) && !state.giftRefused && !giftRefused() &&
      (PROMO_PREVIEW === "cart" || promoWindow());
  }

  // One codebase, two embeds. The mount's data-focus decides which product the bundles are made of.
  var FOCUS = (function () {
    var m = document.getElementById("ozzi-builder");
    return m && m.dataset.focus === "capsules" ? "capsules" : "drinks";
  })();
  var CFG = FOCUS === "capsules" ? {
    heading: "Build Your Capsule Box",
    order: [CAP_ID].concat(DRINK_IDS, TWIN_IDS),
    seed: [CAP_ID],                            // every slot starts as a bottle; a drink is a swap
    noun: "bottle", Noun: "Bottle", NounPl: "Bottles",
    pickLabel: "What goes in your box",
    slotAria: "Item"
  } : {
    heading: "Build Your Box",
    order: DRINK_IDS.concat([CAP_ID], TWIN_IDS),
    seed: SEED_IDS,
    noun: "bag", Noun: "Bag", NounPl: "Bags",
    pickLabel: "Choose your flavors",
    slotAria: "Flavor for bag"
  };
  var ORDER = CFG.order;

  // Preview fallback only (no Liquid). Prices as of the Admin API, 2026-10-13 (drink bags went
  // from $65 to $67; the capsules stayed at $65).
  var SNAPSHOT = {
    45944714887367: { price: 67, compareAt: 67, available: false },   // sold out on the live store
    45944714952903: { price: 67, compareAt: 67, available: true },
    45944777998535: { price: 67, compareAt: 67, available: false },   // sold out on the live store
    45944714920135: { price: 57, compareAt: 67, available: true },
    45944714854599: { price: 67, compareAt: 67, available: true },
    46177427226823: { price: 65, compareAt: 65, available: true },
    68012391923911: { price: 67, compareAt: 67, available: true },    // pre-order twins
    68012391956679: { price: 67, compareAt: 67, available: true }
  };

  var PLAN_FALLBACK = [
    { id: 2968584391, name: "Every 4 Weeks", pct: 20 },
    { id: 2968617159, name: "Every 6 Weeks", pct: 20 },
    { id: 2968649927, name: "Every 8 Weeks", pct: 20 }
  ];

  // Synchronous: the data is already in the document.
  function readCatalog() {
    var el = document.getElementById("ozzi-catalog");
    if (el) {
      try {
        var raw = JSON.parse(el.textContent);
        var out = {};
        (raw.variants || []).forEach(function (v) {
          var sub = {};
          if (v.sub) for (var pid in v.sub) sub[pid] = v.sub[pid] / 100;
          out[v.id] = {
            price: v.price / 100,
            // Retail is never below the price. A compare-at left under a raised price (2026-10-13:
            // $67 bags still carrying $65) made the breakdown start below what the bag costs.
            compareAt: Math.max(v.compareAt || 0, v.price) / 100,
            available: !!v.available,
            low: !!v.low,
            sub: sub,
            image: v.image || ""
          };
        });
        // only trust it if every variant we render is present
        // (pre-order twins excepted: a twin that is gone just means no pre-order; and in the drink
        // builder the capsule bottle: its product crave-crusher-pills went to draft on 2026-11-02, and
        // its absence threw out the whole live catalog, so the builder ran on SNAPSHOT and sent
        // pre-order bags with a selling plan Shopify refuses. Now the bottle just leaves the menu.)
        if (ORDER.every(function (id) { return out[id] || isTwin(id) || (id === CAP_ID && FOCUS !== "capsules"); })) {
          var plans = (raw.sellingPlans || []).length ? raw.sellingPlans : PLAN_FALLBACK;
          return { data: out, plans: plans, live: !!raw.liquid, sample: raw.sample || null,
                   gift: raw.promoGift || null, subPct: planPct(plans) };
        }
      } catch (e) { /* fall through to snapshot */ }
    }
    return { data: SNAPSHOT, plans: PLAN_FALLBACK, live: false, sample: null, gift: null,
             subPct: planPct(PLAN_FALLBACK) };
  }
  // The subscription discount is whatever the selling plan says it is (Skio owns it). Liquid puts
  // each plan's percentage in the catalog, so a change in Skio shows up here with no code change.
  function planPct(plans) {
    for (var i = 0; i < plans.length; i++) if (plans[i].pct > 0) return plans[i].pct / 100;
    return 0;
  }

  // The promo's free bottle: the Free Gift product's variant (id, price, stock, a square crop of the
  // bottle shot), from Liquid. On a live page with no gift product the promo simply does not show:
  // the regular capsule bottle is never a stand-in, since it is in the bundle discounts and the $55
  // discount does not cover it. preview.html has no Liquid, so it borrows the regular bottle's
  // look to draw the row.
  function readGift(res) {
    var g = res.gift;
    if (g && g.id) {
      return { id: g.id, price: g.price / 100, available: !!g.available, image: g.image || "" };
    }
    if (res.live) return null;
    var c = res.data[CAP_ID];
    return c ? { id: CAP_ID, price: c.price, available: !!c.available, image: c.image || "" } : null;
  }

  // ---------- business rules (not in Shopify) ----------
  var STICKS_PER_BAG = 20;
  var DAYS_PER_BOTTLE = 28;
  // Fallback only, for a cached page whose catalog predates the "pct" and "sub" fields. The real
  // figures are read off the selling plan in init. Raised from 15% to 20% in Skio on 2026-10-04.
  var SUB_PCT = 0.20;
  function subPctText() { return Math.round(SUB_PCT * 100) + "%"; }
  var MAX = 10;
  // Subscriptions always ship free. One-time orders ship free at/above this, else the flat rate
  // applies at checkout (the Shopify free-ship discount is subscriber-scoped). Hand-mirrored from
  // the shipping settings, same as the cart drawer's progress bar. It is only used to say
  // "+ shipping" on a one-time price that will be charged it; shipping is never put in a total.
  var FREE_SHIP_MIN = 75;
  // Mirrors the live automatic discounts in Shopify admin ("$6 Off 2+ Items", "$12 off 3+ Items",
  // "4+ Bags"). Changing these numbers WITHOUT changing the three Shopify automatic discounts makes
  // the builder quote a price the cart won't honour. They apply to one-time and subscription alike.
  // "live" is the only profile backed by admin discounts today. "concept" is the homepage-2030
  // ladder and MUST NOT reach a live page until matching automatic discounts exist. Pick a profile
  // per embed with <div id="ozzi-builder" data-offer="concept">.
  var OFFER_PROFILES = {
    live:    function (n) { return n >= 4 ? 15 : (n === 3 ? 12 : (n === 2 ? 6 : 0)); },
    concept: function (n) { return n >= 3 ? 15 : (n === 2 ? 10 : 0); }
  };
  var OFFER_PROFILE = (function () {
    var m = document.getElementById("ozzi-builder");
    return (m && m.dataset.offer && OFFER_PROFILES[m.dataset.offer]) ? m.dataset.offer : "live";
  })();
  function perBagOff(n) { return OFFER_PROFILES[OFFER_PROFILE](n); }

  // Subscription gift ladders, per box size. Hand-mirrored from Skio Surprise and Delight (2026-10-25,
  // drink subscriptions only): 1 bag $10 off order 2, capsules order 4, BIOMEnd order 6; 2 bags $20 off,
  // 3 bags $30 off, 4+ bags $40 off, capsules order 3, BIOMEnd order 4. Change both together.
  // <div id="ozzi-builder" data-ladder="drink"> shows it in place of the three standing perks.
  // Each ladder gives the gifts as pictures (Brandon 2026-10-26: "add the free gift images to the bundle builder
  // boxes as well so they can visually see what all they're getting for free later on") and the rest as perk lines.
  // Gift art is in Shopify Files: the credit coupons are docs/drink-mars-art/out/ozzi-credit-N-off.png, the bottles
  // docs/capsule-bundle-art/parts/{bottle,biomend}.webp, trimmed.
  var GIFT_ART = "https://cdn.shopify.com/s/files/1/0681/5180/4103/files/ozzi-gift-";
  function giftImg(name) { return GIFT_ART + name + ".webp?v=1793030096&width=160"; }
  function ordinal(k) { return k + (k === 1 ? "st" : k === 2 ? "nd" : k === 3 ? "rd" : "th"); }
  // One row of gift cards: a picture (or a drawn voucher ticket in the gift art's colors), a name, and when.
  var TRUCK = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.9"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v9H2z"/>'
    + '<path d="M13 9h4l3 3v3h-7"/><circle cx="6" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';
  function tileRow(tiles) {
    var row = document.createElement("ul");
    row.className = "oz-gifts-row";
    tiles.forEach(function (g) {
      var li = document.createElement("li");
      if (g.fdl) {
        // Tapping it opens snippets/ozzi-fdl-modal (what the app is, and Zach's Instagram).
        li.setAttribute("data-oz-fdl", "");
        li.setAttribute("role", "button");
        li.tabIndex = 0;
        li.setAttribute("aria-haspopup", "dialog");
        li.setAttribute("aria-label", "What is the FDL recipe app?");
      }
      if (g.img) {
        var im = document.createElement("img");
        im.src = g.img; im.alt = ""; im.width = 80; im.height = 80; im.loading = "lazy"; im.decoding = "async";
        li.appendChild(im);
      } else {
        var tk = document.createElement("span");
        tk.className = "oz-tk";
        tk.setAttribute("aria-hidden", "true");
        tk.innerHTML = g.ship ? TRUCK + '<i class="oz-tk-s">FREE</i>'
          : '<i class="oz-tk-n"></i><i class="oz-tk-s">OFF</i>';
        if (g.tk) tk.firstChild.textContent = g.tk;
        li.appendChild(tk);
      }
      var nm = document.createElement("b"); nm.textContent = g.name;
      var wh = document.createElement("span"); wh.textContent = g.when;
      li.appendChild(nm); li.appendChild(wh);
      row.appendChild(li);
    });
    return row;
  }
  // The FDL recipe app trial (Brandon 2026-10-28): a link in the new-subscriber email, so it joins the day-1 row.
  // Shown only while Theme settings > Subscriber gifts is on (the snippet then prints data-fdl-img).
  var FDL_IMG = (function () {
    var m = document.getElementById("ozzi-builder");
    return (m && m.dataset.fdlImg) || "";
  })();
  var LADDERS = {
    // lifePct: the box's whole saving on every delivery (plan + bundle discount), passed in by render().
    drink: function (n, lifePct) {
      var credit = Math.min(n, 4) * 10;
      var caps = n === 1 ? 4 : 3, bio = n === 1 ? 6 : 4;
      return {
        // Later orders only: these sit in the closed "Bonus gifts on future orders" row.
        gifts: [
          { img: giftImg("credit-" + credit), name: "$" + credit + " off", when: "2nd order" },
          { img: giftImg("capsules"), name: "Free capsules", when: ordinal(caps) + " order" },
          { img: giftImg("biomend"), name: "Free BIOMEnd", when: ordinal(bio) + " order" }
        ],
        // The day-1 cards, above the delivery picker. Brandon 2026-10-27: "it should reflect the total savings, so 42%
        // off for life. the bulk discounts apply to all subscription orders moving forward." So the box's own total,
        // not the plan's 20%. The FDL app trial is a day-1 gift too (an email right after the order). Brandon
        // 2026-10-28: cards "the same style as the original free gifts section". The percent changes with every
        // box, so its ticket is drawn by render() (tk) instead of a picture.
        today: [
          { tk: (lifePct || Math.round(SUB_PCT * 100)) + "%", name: (lifePct || Math.round(SUB_PCT * 100)) + "% off", when: "For life" },
          { ship: true, name: "Free shipping", when: "Every order" }
        ].concat(FDL_IMG ? [{ img: FDL_IMG, name: "FDL recipe app", when: "30 days free", fdl: true }] : []),
        lines: [n === 1 ? "Skip or cancel anytime" : "Bundle price locked in, skip or cancel anytime"]
      };
    }
  };
  var LADDER = (function () {
    var m = document.getElementById("ozzi-builder");
    return (m && m.dataset.ladder && LADDERS[m.dataset.ladder]) ? LADDERS[m.dataset.ladder] : null;
  })();

  // A gallery image that follows the box (drink Mars page, 2026-10-26: the bundle offer images are shown only
  // for the box the shopper has picked, not all at once). The product section prints
  // <img data-oz-box-img data-box-1=".." data-box-2=".." ...> with a matching data-alt-N; the gallery slider's
  // clones carry the same attributes, so every copy is updated. Sizes past the last image use the last image.
  function renderBoxImages(n) {
    var imgs = document.querySelectorAll("img[data-oz-box-img]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i], k = Math.max(1, Math.min(n, 9));
      while (k > 1 && !img.getAttribute("data-box-" + k)) k--;
      var src = img.getAttribute("data-box-" + k);
      if (!src || img.getAttribute("src") === src) continue;
      img.setAttribute("src", src);
      var alt = img.getAttribute("data-alt-" + k);
      if (alt) img.setAttribute("alt", alt);
    }
  }

  // The bundle cards. The last one is open-ended: "+ Add another bag" inside it takes the box to 4
  // and beyond (up to MAX), where the $15 tier applies. That tier stays unadvertised, as it was when
  // it was the Bottomless Pit: nothing points at it, it is just there for whoever wants more.
  // Badges: every card shows its percent off. Only the last card gets a word, and "Best Deal" is
  // true of it by construction (the lowest price per bag of the three). There is deliberately no
  // "Most Popular": one bag is the most-ordered size (22 of 49 web orders, 2026-09-26 to 10-04,
  // against 15 for two bags), so the label would be a claim the orders do not back.
  var SIZES = [
    { size: 1, badge: null },
    { size: 2, badge: null },
    { size: 3, badge: "Best Deal", best: true }
  ];
  var LAST_SIZE = SIZES[SIZES.length - 1].size;
  var DEFAULT_SIZE = 2;

  var OFFERS = {
    newcust:  { code: "CRUSH15", pct: 0.15 },
    standard: { code: null, pct: 0 }
  };

  // slots is the box: one variant id per bag, in the order the dropdowns show them. qty is the same
  // box as a variant -> count map, which is what the cart code reads. syncQty() keeps them in step.
  var state = { slots: [], qty: {}, plan: null, freqTouched: false, mode: "newcust",
                sampleLive: SAMPLE_ON, sampleInCart: false, giftRefused: false };

  // 5 free sticks only count once there is something in the box to earn them.
  // In scratch mode the pack stays out of sight until they find it. The pack is still added to the
  // cart either way (the offer is guaranteed); this gates display only.
  function giftShown() { return GIFT_MODE !== "scratch" || !!(scratch && scratch.won); }
  function sampleSticks() { return (state.sampleLive && giftShown()) ? SAMPLE_STICKS : 0; }
  // The gift row lives in the Liquid snippet; the JS is a separate asset, so a cached page can
  // pair old markup with new JS. Missing element must never throw.
  //
  // One gift row, two possible gifts. While a Capsules promo is showing it owns the row; otherwise
  // the row is the Sample Pack, whose art and copy are already in the Liquid markup.
  function renderGift(sampleFree) {
    var g = document.getElementById("gift");
    if (!g) return;
    if (promoShown()) { paintPromoGift(g); return; }
    delete g.dataset.state;
    g.hidden = !sampleFree || GIFT_MODE === "scratch";
  }

  // Locked (fewer than 2 bags) still shows the bottle, so the row doubles as the reason to pick the
  // bigger bundle.
  function paintPromoGift(g) {
    var on = giftEarned();
    var k = Math.max(0, PROMO.buyBags - drinkBags());
    g.hidden = false;
    g.dataset.state = on ? "on" : "locked";
    var img = g.querySelector(".oz-gift-thumb");
    if (img && GIFT.image && img.getAttribute("src") !== GIFT.image) img.setAttribute("src", GIFT.image);
    var title = g.querySelector(".oz-gift-name b");
    var sub = g.querySelector(".oz-gift-name span");
    var price = g.querySelector(".oz-gift-price");
    var tag = g.querySelector(".oz-gift-tag");
    if (title) title.textContent = "Crave Crusher Capsules";
    if (sub) {
      // A subscription only gets the bottle once. Saying "first order" up front is what keeps a
      // subscriber from expecting a free bottle in every refill.
      sub.textContent = on
        ? "28-day bottle, free with your first order"
        : "Add " + k + " more " + (k === 1 ? "bag" : "bags") + " to get it free";
    }
    if (price) {
      price.hidden = !on;
      price.innerHTML = on ? "<s>" + money0(GIFT.price) + "</s>" : "";
    }
    if (tag) tag.textContent = "Free";
  }

  // Bags, not items: capsules in the box do not count toward the bottle. This is the only place the
  // "buy 2 bags" rule exists; Shopify's discount has no bag condition (see PROMO).
  function drinkBags() {
    var n = 0;
    for (var id in state.qty) { var it = itemOf(id); if (it && !it.caps) n += state.qty[id]; }
    return n;
  }
  function giftEarned() { return promoShown() && drinkBags() >= PROMO.buyBags; }

  var ITEMS = [], CATALOG = null, PLANS = [], LIVE = false, GIFT = null;

  function offer() { return OFFERS[state.mode]; }
  function money(n) {
    var s = Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (n < 0 ? "−$" : "$") + s;
  }
  function money0(n) { return "$" + Math.round(n).toLocaleString("en-US"); }
  function cents(n) { return Math.round(n * 100); }

  // ---------- the box ----------
  function itemOf(id) { for (var i = 0; i < ITEMS.length; i++) if (ITEMS[i].id == id) return ITEMS[i]; }
  function picked() { return state.slots.length; }
  function syncQty() {
    var q = {};
    state.slots.forEach(function (id) { q[id] = (q[id] || 0) + 1; });
    state.qty = q;
  }
  // Which card holds a box of n: its own size up to the last card, which also holds everything bigger.
  function activeSize(n) { return n <= 0 ? 0 : Math.min(n, LAST_SIZE); }

  // In-stock ids a new bag may default to, seeds first. Variety before repeats.
  function pool() {
    var ids = [];
    function take(id) { var it = itemOf(id); if (it && it.available && !it.twinOf && ids.indexOf(id) === -1) ids.push(id); }
    CFG.seed.forEach(take);
    if (FOCUS !== "capsules") DRINK_IDS.forEach(take);
    if (!ids.length) ITEMS.forEach(function (it) { take(it.id); });   // last resort: anything buyable
    return ids;
  }
  function nextDefault(cur) {
    var p = pool();
    if (!p.length) return null;
    for (var i = 0; i < p.length; i++) if (cur.indexOf(p[i]) === -1) return p[i];
    return p[cur.length % p.length];
  }
  // The box a card of this size would hold if it were picked right now: the shopper's current bags
  // first, then defaults. A card is PRICED from exactly this, so tapping it never moves its price.
  function slotsFor(size) {
    var out = state.slots.slice(0, size);
    while (out.length < size) {
      var id = nextDefault(out);
      if (!id) break;
      out.push(id);
    }
    return out;
  }

  function contentsOf(slots) {
    var bags = 0, bottles = 0;
    slots.forEach(function (id) { var it = itemOf(id); if (!it) return; if (it.caps) bottles++; else bags++; });
    return { bags: bags, bottles: bottles };
  }
  // "2 Bags", "1 Bottle", "2 Bags + 1 Bottle"
  function nameFor(slots) {
    var c = contentsOf(slots), p = [];
    if (c.bags) p.push(c.bags + (c.bags === 1 ? " Bag" : " Bags"));
    if (c.bottles) p.push(c.bottles + (c.bottles === 1 ? " Bottle" : " Bottles"));
    return p.join(" + ");
  }
  // "40 sticks", "28-day supply", "40 sticks + 1 bottle of capsules"
  function describeSlots(slots) {
    var c = contentsOf(slots), p = [];
    if (c.bags) p.push((c.bags * STICKS_PER_BAG + sampleSticks()) + " sticks");
    if (c.bottles) p.push(c.bags ? c.bottles + (c.bottles === 1 ? " bottle" : " bottles") + " of capsules"
                                 : (c.bottles * DAYS_PER_BOTTLE) + "-day supply");
    return p.join(" + ");
  }
  function unitFor(slots) {
    var c = contentsOf(slots);
    return c.bags && c.bottles ? " each" : (c.bottles ? "/bottle" : "/bag");
  }

  // ---------- the discount chain, one source of truth ----------
  // Order matters. The selling plan discount is baked into the LINE price (a $67 variant bills at
  // $53.60 on the 20% plan), and the per-item automatic discount comes off that at full dollar
  // value. Applying the percentage after the bundle discount discounts the discount.
  // The subscribed unit price is the selling plan allocation's own price, straight from Shopify.
  // A pre-order twin that is not in the subscription plans yet (Skio adds variants; the store's API
  // cannot) goes in as a one-time line, so its subscribed price is just its price.
  function subscribable(it) {
    return !it.twinOf || !!(it.sub && Object.keys(it.sub).length) || !LIVE;
  }
  function linePlanFor(id, plan) {
    var it = itemOf(id);
    return plan && it && !subscribable(it) ? null : plan;
  }
  function subPriceOf(it, planId) {
    if (!subscribable(it)) return it.price;
    var p = it.sub ? it.sub[planId] : undefined;
    return (p || p === 0) ? p : Math.round(it.price * (1 - SUB_PCT) * 100) / 100;
  }
  function ladder(compare, sale, subSale, n, subOn) {
    var subCut = subOn ? sale - subSale : 0;      // the plan's cut, exact per unit
    var bundleCut = n * perBagOff(n);             // full dollar value, not scaled
    var base = sale - subCut - bundleCut;
    var o = offer();
    var codeCut = o.code ? Math.round(base * o.pct * 100) / 100 : 0;
    var pay = Math.round((base - codeCut) * 100) / 100;
    return {
      retail: compare, bundleCut: bundleCut,
      subCut: subCut, codeCut: codeCut, pay: pay,
      saved: compare - pay,
      // whole percent, always rounded UP (Brandon 2026-10-26: "round the buy box discounts up, not down", then
      // "we didn't round the bundle builders up to the proper % off" when 41.3% read 41%). Integer ceiling in
      // cents, so an exact 20% stays 20 and never becomes 21 from float noise.
      pctOff: pctUp(compare, pay)
    };
  }
  function pctUp(compare, pay) {
    return compare > 0 ? Math.floor(((cents(compare) - cents(pay)) * 100 + cents(compare) - 1) / cents(compare)) : 0;
  }
  function quoteSlots(slots, subOn, planId) {
    var compare = 0, sale = 0, subSale = 0;
    slots.forEach(function (id) {
      var it = itemOf(id);
      if (!it) return;
      compare += it.compareAt;
      sale += it.price;
      subSale += subPriceOf(it, planId);
    });
    return ladder(compare, sale, subSale, slots.length, subOn);
  }

  // ---------- build ----------
  var bundlesEl = document.getElementById("bundles");
  var panelEl = document.getElementById("panel");
  var flavsEl = document.getElementById("flavs");
  var freqEl = document.getElementById("freq");
  // A page cached from before 2026-10-04 still carries the stepper's markup. Against that this
  // script has nothing to build into, so it stops here instead of throwing halfway through init.
  if (!bundlesEl || !panelEl || !flavsEl || !freqEl || !document.getElementById("cta")) {
    console.error("[ozzi-builder] markup and script are from different builds; reload the page");
    return;
  }

  function buildItems() {
    ITEMS = ORDER.map(function (id) {
      var a = ART[id], c = CATALOG[id] || { price: 67, compareAt: 67, available: false };
      return {
        id: id, name: a.name, tag: a.tag, img: c.image || "", caps: !!a.caps, twinOf: a.twinOf || 0,
        price: c.price, compareAt: c.compareAt, available: c.available, low: !!c.low, sub: c.sub || {},
        known: !!CATALOG[id]
      };
    });
    // Pre-order: a twin stays only while it can be bought and its original cannot. Its original
    // then leaves the menu (the twin stands in for it) but stays in the sold-out list below,
    // which carries the waitlist and the ship date.
    var byId = {};
    ITEMS.forEach(function (it) { byId[it.id] = it; });
    ITEMS = ITEMS.filter(function (it) {
      if (!it.twinOf) return it.known || !LIVE;            // not in the live catalog: not on offer
      var orig = byId[it.twinOf];
      var on = it.known && it.available && !(orig && orig.available);
      if (on && orig) orig.preorderBy = it.id;
      return on;
    });
    // Sold-out flavours sink to the bottom so the ones we can actually ship lead the list, with
    // pre-orders between the two. Stable partition, so each group keeps its curated order.
    var inStock = [], pre = [], soldOut = [];
    ITEMS.forEach(function (it) { (it.twinOf ? pre : (it.available ? inStock : soldOut)).push(it); });
    ITEMS = inStock.concat(pre, soldOut);
    // Per-flavour markdown: flag any drink flavour priced below the going drink price (the most a
    // drink costs here) as "$N off". Derived from the live catalog, so it tracks whatever Shopify
    // says and clears itself when prices are level again. Drinks only.
    var drinkPrices = ITEMS.filter(function (it) { return !it.caps && it.price > 0; })
                           .map(function (it) { return it.price; });
    var going = drinkPrices.length ? Math.max.apply(null, drinkPrices) : 0;
    ITEMS.forEach(function (it) {
      var off = (!it.caps && going && it.price > 0) ? going - it.price : 0;
      it.saleOff = off >= 1 ? Math.round(off) : 0;   // whole-dollar note; ignore sub-$1 float noise
    });
  }

  // One card per bundle size. Built once; render() fills them in.
  // The head is a real <label> around a real radio, so the keyboard and screen readers get a radio
  // group for free. The flavour panel is NOT inside the label: a label wrapping other controls
  // would forward their clicks to the radio.
  function buildBundles() {
    [].slice.call(bundlesEl.querySelectorAll(".oz-bundle")).forEach(function (el) { el.parentNode.removeChild(el); });
    SIZES.forEach(function (sz) {
      var el = document.createElement("div");
      el.className = "oz-bundle";
      el.dataset.size = sz.size;
      el.innerHTML =
        '<span class="oz-bundle-badge' + (sz.best ? " is-best" : "") + '"></span>' +
        '<label class="oz-bundle-head">' +
          '<input type="radio" class="oz-bundle-radio" name="oz-bundle" value="' + sz.size + '">' +
          '<span class="oz-bundle-main">' +
            '<span class="oz-bundle-name"></span>' +
            '<span class="oz-bundle-sub"></span>' +
          "</span>" +
          '<span class="oz-bundle-price"><strong></strong><span class="oz-vh oz-bundle-was" hidden>Regular price </span><s></s></span>' +
        "</label>";
      bundlesEl.appendChild(el);
    });
  }
  function cardOf(size) { return bundlesEl.querySelector('.oz-bundle[data-size="' + size + '"]'); }

  // The dropdown's options. Sold-out flavours stay listed (disabled), because "where did Cherry
  // Limeade go" is a worse question than "Cherry Limeade is sold out".
  function optionLabel(it) {
    // The date stays out of the menu: a closed dropdown on a phone cut it to "Pre-order, s…".
    // The note under the dropdowns carries it the moment a pre-order bag is picked.
    if (it.twinOf) return it.name + " · Pre-order";
    if (!it.available) return it.name + " · Sold out";
    if (it.saleOff) return it.name + " · $" + it.saleOff + " off";
    if (it.low) return it.name + " · Low stock";
    return it.name + (it.tag ? " · " + it.tag : "");
  }
  function optionsHtml() {
    function group(label, list) {
      if (!list.length) return "";
      return '<optgroup label="' + label + '">' + list.map(function (it) {
        return '<option value="' + it.id + '"' + (it.available ? "" : " disabled") + ">" + optionLabel(it) + "</option>";
      }).join("") + "</optgroup>";
    }
    var drinks = ITEMS.filter(function (it) { return !it.caps && !it.preorderBy; });   // a twin stands in
    var caps = ITEMS.filter(function (it) { return it.caps; });
    var d = group("Drink mix, 20 sticks a bag", drinks), c = group("Capsules, 28-day bottle", caps);
    return FOCUS === "capsules" ? c + d : d + c;
  }

  // The sold-out flavours and their waitlist, folded behind one line under the dropdowns.
  function buildOos() {
    var box = document.getElementById("oos");
    if (!box) return;
    var out = ITEMS.filter(function (it) { return !it.available && !it.caps; });
    box.hidden = !out.length;
    if (!out.length) return;
    var label = box.querySelector(".oz-oos-label");
    var pre = out.filter(function (it) { return it.preorderBy; }).length;
    if (label) label.textContent = pre === out.length
      ? (pre === 1 ? "1 flavor on pre-order" : pre + " flavors on pre-order")
      : (out.length === 1 ? "1 flavor sold out" : out.length + " flavors sold out");
    var list = box.querySelector(".oz-oos-list");
    if (!list) return;
    list.innerHTML = out.map(function (it) {
      return '<div class="oz-item" data-id="' + it.id + '" data-oos="true">' +
        '<img class="oz-thumb" src="' + it.img + '" alt="">' +
        '<div class="oz-item-name"><b>' + it.name + "</b>" +
          (it.preorderBy
            ? '<span class="oz-tag oz-tag-pre">Pre-order</span>' +
              '<span class="oz-item-note oz-item-restock">Ships around ' + PREORDER_SHIP + "</span>"
            : '<span class="oz-tag oz-tag-oos">Sold Out</span>' +
              '<span class="oz-item-note oz-item-restock">' + RESTOCK_TEXT + "</span>") +
        "</div>" +
        '<div class="oz-step" data-step>' + waitlistBtnHtml(it) + "</div>" +
        waitlistFormHtml(it) +
      "</div>";
    }).join("");
  }

  // The waitlist is split across two cells on purpose. The BUTTON goes in the row's action column.
  // The FORM spans the whole row underneath (grid-column 1/-1), because an email field plus a
  // submit button cannot fit in that narrow column.
  function waitlistBtnHtml(it) {
    if (it.available) return "";
    if (!waitlistFor(it.id)) return "";          // no list configured -> nothing, not a dead button
    if (alreadyJoined(it.id)) return '<span class="oz-wait-on">On the list</span>';
    return '<button type="button" class="oz-wait-btn" data-wait-open>Join Waitlist</button>';
  }

  function waitlistFormHtml(it) {
    if (it.available || !waitlistFor(it.id) || alreadyJoined(it.id)) return "";
    var iid = "ozwait-" + it.id;
    return '<div class="oz-wait" data-wait>' +
      '<form class="oz-wait-form" data-wait-form hidden>' +
        '<label class="oz-wait-lbl" for="' + iid + '">Email me when ' + it.name + ' is back</label>' +
        '<div class="oz-wait-row">' +
          '<input class="oz-wait-input" id="' + iid + '" type="email" name="email" required ' +
            'autocomplete="email" inputmode="email" placeholder="you@email.com">' +
          '<button type="submit" class="oz-wait-go">Notify Me</button>' +
        "</div>" +
      "</form>" +
      '<p class="oz-wait-msg" data-wait-msg role="status" hidden></p>' +
      "</div>";
  }

  // ---------- delivery frequency ----------
  // Bigger boxes last longer, so they default to a longer cadence: 1 bag every 4 weeks, 2 every 6,
  // 3 or more every 8 (the longest plan there is). Moved out a step on 2026-10-04 (Brandon; it was
  // 4 / 4 / 6, and 8 only from four bags): subscribers were being sent the next box before the last
  // one was finished, and "too much product" is what they cancel over. Only the DEFAULT moves; a
  // manual pick sticks, for every size. The quiz keeps its own copy of this rule
  // (ozzi-quiz/lib/config.ts, defaultSellingPlan), which has to be changed by hand to match.
  function defaultWeeksFor(n) { return n >= 3 ? 8 : (n === 2 ? 6 : 4); }
  function planIdForWeeks(weeks) {
    for (var i = 0; i < PLANS.length; i++) {
      var m = /(\d+)\s*week/i.exec(PLANS[i].name);
      if (m && parseInt(m[1], 10) === weeks) return String(PLANS[i].id);
    }
    return PLANS.length ? String(PLANS[0].id) : "";
  }
  function planFor(n) {
    return (state.freqTouched && state.plan) ? state.plan : planIdForWeeks(defaultWeeksFor(n));
  }
  function planById(id) {
    for (var i = 0; i < PLANS.length; i++) if (String(PLANS[i].id) === String(id)) return PLANS[i];
    return null;
  }
  // "every 4 weeks", read off the plan's own name ("Every 4 Weeks", "Delivered every 4 weeks").
  function cadence(planId) {
    var p = planById(planId);
    if (!p) return "on your schedule";
    var m = /(\d+)\s*(day|week|month)/i.exec(p.name);
    return m ? "every " + m[1] + " " + m[2].toLowerCase() + (m[1] === "1" ? "" : "s") : p.name.toLowerCase();
  }

  function buildPlans() {
    freqEl.innerHTML = PLANS.map(function (p) {
      return '<option value="' + p.id + '">' + p.name + "</option>";
    }).join("");
  }

  // ---------- scratch-to-reveal gift (A/B variant, paused with the Sample Pack) ----------
  // Presentation only. The pack is guaranteed either way: the commit puts it in the cart as the box
  // holds a qualifying item, scratched or not, so nobody loses the offer by ignoring the game.
  // What varies is how the gift is discovered, which is the whole point of the test.
  //
  // One of the three genuinely hides the gift, picked at random and pinned for the session, so
  // scratching the right one first wins immediately. Held in sessionStorage rather than re-rolled
  // per render, otherwise a reload would shuffle the prize out from under a half-played card.
  // The "no" cards deliberately name no prize: implying a prize nobody can win is the part of this
  // pattern that draws deceptive-promotion complaints.
  var SC_CLEAR = 0.5;
  var SC_LOSE = ["Not this one", "Keep going"];
  var SC_LOSE_DONE = "Nothing here";   // scratched after the gift was already found
  var scratch = { opened: 0, lost: 0, won: false };
  var SC_WIN = (function () {
    var pick = Math.floor(Math.random() * 3);
    try {
      var v = sessionStorage.getItem("ozzi_scratch_win");
      if (v !== null && v >= 0 && v <= 2) return parseInt(v, 10);
      sessionStorage.setItem("ozzi_scratch_win", String(pick));
    } catch (e) { /* private mode: just use this load's pick */ }
    return pick;
  })();
  // Borrow the sample art the gift row already loads, so the winning card shows the real pack with
  // no extra Liquid plumbing. The preview inlines markup unprocessed, so skip a raw Liquid src.
  var SC_IMG = (function () {
    var t = document.querySelector("#gift .oz-gift-thumb");
    var src = t && t.getAttribute("src");
    return (src && src.indexOf("{{") === -1) ? src : "";
  })();

  // Match the backing store to the rendered box (capped at 2x) instead of stretching one fixed
  // bitmap. Resizing a canvas clears it, so this only runs when painting.
  function sizeFoil(cv) {
    var r = cv.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round((r.width || 160) * dpr));
    var h = Math.max(1, Math.round((r.height || 110) * dpr));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    return dpr;
  }

  // Brush radius in CSS pixels, so it stays a finger-sized target on a phone.
  function brushCss(cv) {
    var r = cv.getBoundingClientRect();
    return Math.max(20, Math.min(32, (r.width || 160) * 0.24));
  }

  function paintFoil(cv) {
    var dpr = sizeFoil(cv);
    var ctx = cv.getContext("2d");
    ctx.globalCompositeOperation = "source-over";   // reset: scratching leaves destination-out set
    var g = ctx.createLinearGradient(0, 0, cv.width, cv.height);
    g.addColorStop(0, "#E4C86B"); g.addColorStop(0.5, "#F5E7B4"); g.addColorStop(1, "#D3B457");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, cv.width, cv.height);
    ctx.fillStyle = "rgba(74,63,22,.5)";
    ctx.font = "800 " + Math.round(13 * dpr) + "px ui-sans-serif, system-ui, -apple-system, sans-serif";
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText("SCRATCH", cv.width / 2, cv.height / 2);
  }

  function scratchDot(cv, clientX, clientY) {
    var r = cv.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var s = cv.width / r.width;   // canvas px per CSS px
    var ctx = cv.getContext("2d");
    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    ctx.arc((clientX - r.left) * s, (clientY - r.top) * (cv.height / r.height), brushCss(cv) * s, 0, Math.PI * 2);
    ctx.fill();
  }

  // Sampled, not exhaustive: every 32nd pixel is plenty to decide "mostly cleared".
  function foilCleared(cv) {
    var d = cv.getContext("2d").getImageData(0, 0, cv.width, cv.height).data;
    var clear = 0, total = 0;
    for (var i = 3; i < d.length; i += 128) { total++; if (d[i] < 40) clear++; }
    return total ? clear / total : 0;
  }

  function openCard(card) {
    if (card.dataset.done === "true") return;
    card.dataset.done = "true";
    var win = parseInt(card.dataset.i, 10) === SC_WIN;
    card.dataset.win = win ? "true" : "false";
    var body = card.querySelector(".oz-sc-body");
    if (win) {
      body.innerHTML = (SC_IMG ? '<img class="oz-sc-img" src="' + SC_IMG + '" alt="">' : "") +
        '<span class="oz-sc-txt">Free Sample Pack</span>' +
        '<span class="oz-sc-sub">5 sticks, one of every flavor</span>';
    } else {
      // The other cards keep their foil after the win, so a loser scratched afterwards needs copy
      // that doesn't tell someone holding the gift to "keep going".
      body.innerHTML = '<span class="oz-sc-txt">' +
        (scratch.won ? SC_LOSE_DONE : SC_LOSE[Math.min(scratch.lost, SC_LOSE.length - 1)]) + "</span>";
      scratch.lost++;
    }
    var cv = card.querySelector("canvas");
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    card.classList.add("is-open");
    scratch.opened++;
    var cnt = document.getElementById("scratchCount");
    if (cnt) cnt.textContent = scratch.opened + "/3";
    if (!win) return;
    scratch.won = true;
    card.classList.add("is-win");   // pop + glow, skipped under prefers-reduced-motion
    var panel = document.getElementById("scratch");
    if (panel) panel.classList.add("is-won");
    var t = document.getElementById("scratchTitle"), note = document.getElementById("scratchNote");
    if (t) t.textContent = "Congrats, you won a Free Ozzi Sample Pack";
    if (note) note.textContent = "5 sticks, one of every flavor. Added free with your order.";
    render();
  }

  function wireCard(card) {
    var cv = card.querySelector("canvas"), drawing = false;
    function move(x, y) {
      if (card.dataset.done === "true") return;
      card.dataset.touched = "true";   // don't let a resize repaint over work in progress
      scratchDot(cv, x, y);
      if (foilCleared(cv) > SC_CLEAR) openCard(card);
    }
    // Both halves of the mobile fix live here: touch-action:none in the CSS, plus preventDefault on
    // NON-passive touch listeners. A passive listener silently ignores preventDefault, which is the
    // usual reason a scratch canvas scrolls the page under the finger instead of scratching.
    cv.addEventListener("touchstart", function (e) {
      e.preventDefault();
      var t = e.touches[0]; if (t) move(t.clientX, t.clientY);
    }, { passive: false });
    cv.addEventListener("touchmove", function (e) {
      e.preventDefault();
      var t = e.touches[0]; if (t) move(t.clientX, t.clientY);
    }, { passive: false });
    cv.addEventListener("mousedown", function (e) { drawing = true; move(e.clientX, e.clientY); });
    cv.addEventListener("mousemove", function (e) { if (drawing) move(e.clientX, e.clientY); });
    document.addEventListener("mouseup", function () { drawing = false; });
    // Keyboard route, so the gift is never locked behind the ability to drag.
    cv.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openCard(card); }
    });
  }

  function buildScratch() {
    var panel = document.getElementById("scratch"), row = document.getElementById("scratchRow");
    if (!panel || !row) return;
    panel.hidden = GIFT_MODE !== "scratch";
    if (panel.hidden) return;
    row.innerHTML = "";
    for (var i = 0; i < 3; i++) {
      var card = document.createElement("div");
      card.className = "oz-sc";
      card.dataset.i = i;
      card.innerHTML = '<div class="oz-sc-body"><span class="oz-sc-txt"></span></div>' +
        '<canvas class="oz-sc-foil" role="button" tabindex="0" aria-label="Scratch to reveal your gift"></canvas>';
      row.appendChild(card);
      paintFoil(card.querySelector("canvas"));   // sized from the box it just landed in
      wireCard(card);
    }
    // A rotate or resize leaves the backing store the wrong shape, so repaint the cards nobody has
    // touched yet. Opened cards keep their revealed face; a half-scratched one is left alone.
    var reT = null;
    window.addEventListener("resize", function () {
      clearTimeout(reT);
      reT = setTimeout(function () {
        [].forEach.call(document.querySelectorAll("#ozzi-builder .oz-sc"), function (c) {
          if (c.dataset.done === "true" || c.dataset.touched === "true") return;
          paintFoil(c.querySelector("canvas"));
        });
      }, 160);
    });
  }

  // ---------- events ----------
  function setSize(size) {
    state.slots = slotsFor(size);
    syncQty();
    saveBox();
    render();
  }

  function wire() {
    // Pick a bundle. The radio's own change covers a tap on the head (it is a label) and the arrow
    // keys; the click handler covers the rest of the card (the badge, the padding).
    bundlesEl.addEventListener("change", function (e) {
      var r = e.target.closest(".oz-bundle-radio");
      if (!r || !r.checked) return;
      setSize(parseInt(r.value, 10));
    });
    bundlesEl.addEventListener("click", function (e) {
      var b = e.target.closest(".oz-bundle");
      if (!b || b.dataset.active === "true" || b.dataset.off === "true") return;
      if (e.target.closest(".oz-bundle-head")) return;       // the label does this itself
      setSize(parseInt(b.dataset.size, 10));
    });

    // Pick a flavour for one bag.
    flavsEl.addEventListener("change", function (e) {
      var s = e.target.closest(".oz-flav-select");
      if (!s) return;
      var i = parseInt(s.dataset.slot, 10), id = parseInt(s.value, 10);
      if (!(i >= 0) || !itemOf(id)) return;
      state.slots[i] = id;
      syncQty();
      saveBox();
      render();
    });
    // Take an extra bag back out (only bags past the third have the button).
    flavsEl.addEventListener("click", function (e) {
      var x = e.target.closest("[data-remove]");
      if (!x) return;
      var i = parseInt(x.dataset.remove, 10);
      if (!(i >= LAST_SIZE) || i >= state.slots.length) return;
      state.slots.splice(i, 1);
      syncQty();
      saveBox();
      render();
      var more = document.getElementById("more");
      if (more && !more.hidden) more.focus();
    });
    // One more bag, past the last card's size.
    var moreEl = document.getElementById("more");
    if (moreEl) moreEl.addEventListener("click", function () {
      if (picked() >= MAX) return;
      var id = nextDefault(state.slots);
      if (!id) return;
      state.slots.push(id);
      syncQty();
      saveBox();
      render();
      var sel = flavsEl.querySelector('.oz-flav-select[data-slot="' + (state.slots.length - 1) + '"]');
      if (sel) sel.focus();
    });

    freqEl.addEventListener("change", function () {
      state.plan = freqEl.value;
      state.freqTouched = true;
      render();
    });

    // Waitlist. Delegated on the sold-out group so it survives a rebuild.
    var oos = document.getElementById("oos");
    if (oos) {
      oos.addEventListener("click", function (e) {
        var open = e.target.closest("[data-wait-open]");
        if (!open) return;
        // The button sits in the step cell and the form in a sibling cell, so resolve through the
        // ROW rather than an ancestor: they are cousins in the grid, not parent and child.
        var row = open.closest(".oz-item");
        var form = row && row.querySelector("[data-wait-form]");
        if (!form) return;
        open.hidden = true;
        form.hidden = false;
        var input = form.querySelector("input");
        if (input) input.focus();
      });

      oos.addEventListener("submit", function (e) {
        var form = e.target.closest("[data-wait-form]");
        if (!form) return;
        e.preventDefault();                                  // never let it navigate away mid-build
        var row = form.closest(".oz-item");
        var box = form.closest("[data-wait]");
        var msg = box.querySelector("[data-wait-msg]");
        var input = form.querySelector("input");
        var go = form.querySelector(".oz-wait-go");
        var id = parseInt(row.dataset.id, 10);
        var list = waitlistFor(id);
        var email = (input.value || "").trim();
        if (!list || !email) return;

        go.disabled = true; input.disabled = true;
        var goLabel = go.textContent;
        go.textContent = "Adding…";
        msg.hidden = true; msg.className = "oz-wait-msg";

        var name = (ART[id] && ART[id].name) || "this flavor";
        joinWaitlist(list, email, name)
          .then(function () {
            markJoined(id);
            form.hidden = true;
            msg.textContent = "You are on the list. We will email you when it is back.";
            msg.className = "oz-wait-msg is-ok";
            msg.hidden = false;
            // Swap the step cell's now-hidden button for the standing confirmation, so the row
            // matches what a reload would render instead of leaving an empty action slot.
            var step = row.querySelector("[data-step]");
            if (step) step.innerHTML = '<span class="oz-wait-on">On the list</span>';
          })
          .catch(function (err) {
            console.error("[ozzi-builder] waitlist:", (err && err.message) || err);
            go.disabled = false; input.disabled = false; go.textContent = goLabel;
            msg.textContent = "That did not go through. Please try again.";
            msg.className = "oz-wait-msg is-err";
            msg.hidden = false;
          });
      });
    }

    // Preview-bar controls. Absent on the real page: the embed decides the mode.
    var mNew = document.getElementById("mNew");
    var mStd = document.getElementById("mStd");
    if (mNew) mNew.addEventListener("click", function () { state.mode = "newcust"; render(); });
    if (mStd) mStd.addEventListener("click", function () { state.mode = "standard"; render(); });

    // Two buttons, two purchase types, the same box. Nothing here is a mode: each button says what
    // it does and does only that.
    var cta = document.getElementById("cta");
    var once = document.getElementById("once");
    cta.addEventListener("click", function () { addToCart(true, cta); });
    if (once) once.addEventListener("click", function () { addToCart(false, once); });
  }

  // ---------- cart ----------
  // ONE write, at a button. The box is local state until the shopper commits: the whole thing goes
  // in as a single batched /cart/add.js and the browser goes straight to checkout.
  //
  // Each flavour is still its own line (not a bundle variant), so Shopify's automatic discounts
  // ($6 off 2+, $12 off 3+, $15 off 4+) do the tier pricing at the cart with real per-flavour
  // lines and inventory. A first-order code (CRUSH15) rides the session from a
  // /discount/CRUSH15?redirect= link, and from applyOfferCode() below.
  function cartPost(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || r.status); });
      return r.json();
    });
  }
  // Put a first-order code the builder is PRICING IN (e.g. CRUSH15) onto the session, whatever route
  // the visitor took to get here. Organic, direct, shared, or mis-tagged URLs skip the /discount/
  // link, so the shopper saw the discounted price and was then charged full at checkout. We assert it
  // on load (covers checkout from the drawer or /cart, not just a button) and again at commit. Gated
  // on offer().code, so cohort/sample pages (mode "standard", no code) never apply it. Idempotent:
  // re-applying a code already on the session is a no-op.
  function applyOfferCode() {
    var o = offer();
    if (!o || !o.code) return Promise.resolve();
    // ?redirect=/cart.js: same cookie, but an ~8 KB JSON reply instead of the ~409 KB storefront
    // page (measured 2026-09-04).
    return fetch(cartRoot() + "/discount/" + encodeURIComponent(o.code) + "?redirect=/cart.js",
                 { credentials: "same-origin", headers: { Accept: "application/json" } }).catch(function () {});
  }
  // The plan a subscription commit goes in on. Read at COMMIT time: the cadence can change while
  // the box is being built, so reading it any earlier risks committing lines on a plan the shopper
  // has since moved off.
  function currentPlan() {
    var v = parseInt(planFor(picked()), 10);
    return v || null;
  }
  function cartRoot() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/$/, "");
  }

  function getCart() {
    return fetch(cartRoot() + "/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }
  function sampleLineOf(cart) {
    var found = null;
    (cart.items || []).forEach(function (l) { if ((l.variant_id || l.id) === SAMPLE_ID) found = l; });
    return found;
  }

  // The free pack is settled BEFORE the button leaves for checkout, and the button waits on it:
  // put the pack in, read the price back, and keep it only if Shopify made it free. It is in the
  // cart at $0 or not in it at all by the time anyone can pay. Resolves either way; a failure here
  // must not cost the order.
  function settleSample() {
    if (!SAMPLE_ON || !giftShown() || picked() === 0) return Promise.resolve();
    var quiet = { credentials: "same-origin", headers: { Accept: "application/json" } };
    // Same one-request trick as the commit: put the BXGY on the session and read the cart back.
    return fetch(cartRoot() + "/discount/" + SAMPLE_CODE + "?redirect=/cart.js", quiet)
      .then(function (r) { return r.json(); })
      .catch(getCart)
      .then(function (cart) {
        var line = sampleLineOf(cart);
        if (line && line.final_line_price === 0) {          // already there and free
          state.sampleInCart = true; state.sampleLive = true;
          return null;
        }
        if (line) return line;                              // there but priced, handled below
        return cartPost("/cart/add.js", { items: [{ id: SAMPLE_ID, quantity: 1 }] })
          .then(getCart).then(sampleLineOf);
      })
      .then(function (line) {
        if (!line) return null;
        if (line.final_line_price === 0) {                  // free: it stays
          state.sampleInCart = true;
          state.sampleLive = true;
          return null;
        }
        // Priced: the offer is not live on this cart. Pull it back out, so checkout never shows a
        // charge nobody agreed to pay.
        state.sampleInCart = false;
        state.sampleLive = false;
        return cartPost("/cart/change.js", { id: line.key, quantity: 0 });
      })
      .catch(function (e) { console.error("[ozzi-builder] sample:", (e && e.message) || e); });
  }

  // Tell the theme its cart changed so the pop-up cart drawer (and header count) re-render in
  // place. Without this the drawer only reflects a builder edit after a full page refresh.
  function notifyCartUI() {
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "ozzi-builder" });
      }
    } catch (e) {}
  }

  // Repaint the drawer's contents and the header count WITHOUT opening the drawer. renderContents()
  // always opens it, which is right straight after a button and wrong for a correction made on page
  // load or after an edit elsewhere. Same section ids and selectors the drawer uses itself.
  function repaintDrawerQuietly() {
    return cartPost("/cart/update.js", { updates: {}, sections: DRAWER_SECTIONS, sections_url: location.pathname })
      .then(function (res) {
        var d = cartDrawer();
        if (!d || !res || !res.sections || typeof d.getSectionsToRender !== "function") { notifyCartUI(); return; }
        d.getSectionsToRender().forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          var html = res.sections[s.id];
          if (el && html) el.innerHTML = d.getSectionInnerHTML(html, s.selector);
        });
        d.classList.toggle("is-empty", !res.item_count);
      })
      .catch(function () { notifyCartUI(); });
  }

  // ---------- the promo bottle in the cart ----------
  function isGiftLine(line) { return !!(line && line.properties && line.properties[PROMO.prop]); }
  function giftLinesOf(cart) { return (cart.items || []).filter(isGiftLine); }
  // Counted off the cart by PRODUCT: every flavour and selling plan of the drink, whether or not the
  // builder put it there.
  function bagsInCart(cart) {
    var n = 0;
    (cart.items || []).forEach(function (l) {
      if (!isGiftLine(l) && l.product_id === PROMO.drinkProduct) n += l.quantity;
    });
    return n;
  }
  function giftItem() {
    var props = {};
    props[PROMO.prop] = PROMO.propValue;
    return { id: GIFT.id, quantity: 1, properties: props };   // one-time: no selling plan, ever
  }

  // Puts the cart right for the two free items, after a button, on page load, and after any cart
  // edit made outside the builder (the drawer's own +/-):
  //   - the promo bottle: exactly one while 2+ bags are in the cart and the promo is running, none
  //     otherwise, and never one Shopify has not zeroed;
  //   - the paused Sample Pack: a pack left over from an earlier visit stays only while Shopify still
  //     zeroes it, so it can never reach checkout at $20.
  // With no promo running this still does the second half of the first job: a bottle left in a cart
  // from before the end is taken out. Every write here is quiet (no sections, no open drawer) until
  // the end, so nobody ever sees a price on a free item: it appears at $0 or not at all.
  // Resolves true when it wrote to the cart (or may have), false when the cart was already right.
  // A call that lands while one is running gets that run's promise, which also covers the re-run
  // it asks for: the buttons wait on this before leaving for checkout.
  var settling = null, settleAgain = false;
  function settleCart(cart) {
    if (settling) { settleAgain = true; return settling; }
    var lines = giftLinesOf(cart);
    var want = promoCart() && bagsInCart(cart) >= PROMO.buyBags;
    var keep = want ? (lines[0] || null) : null;
    var drop = lines.filter(function (l) { return l !== keep; });
    var sample = SAMPLE_ON ? null : sampleLineOf(cart);
    if (sample && sample.final_line_price > 0) drop.push(sample);
    var add = want && !keep;
    var fixQty = !!(keep && keep.quantity !== 1);
    var priced = !!(keep && keep.final_line_price > 0);
    if (!drop.length && !add && !fixQty && !priced) return Promise.resolve(false);

    var chain = Promise.resolve();
    drop.forEach(function (l) {
      chain = chain.then(function () { return cartPost("/cart/change.js", { id: l.key, quantity: 0 }); });
    });
    if (fixQty) chain = chain.then(function () { return cartPost("/cart/change.js", { id: keep.key, quantity: 1 }); });
    if (add) chain = chain.then(function () { return cartPost("/cart/add.js", { items: [giftItem()] }); });
    settling = chain
      .then(getCart)
      .then(function (c) {
        var l = giftLinesOf(c)[0];
        if (!want || !l || l.final_line_price === 0) return null;
        // Priced: the discount is not live on this cart. Out it comes before anyone sees the price,
        // and the builder stops advertising the promo for the rest of the visit.
        refuseGift();
        return cartPost("/cart/change.js", { id: l.key, quantity: 0 });
      })
      // A button on its way to checkout has no use for a repainted drawer.
      .then(function () { render(); return committing ? null : repaintDrawerQuietly(); })
      .catch(function (e) { console.error("[ozzi-builder] gift:", (e && e.message) || e); })
      .then(function () {
        settling = null;
        if (!settleAgain) return true;
        settleAgain = false;
        return getCart().then(settleCart).catch(function () {}).then(function () { return true; });
      });
    return settling;
  }

  // ---------- remembering the box ----------
  // Nothing is written to the cart until a button, so a reload would drop a half-built box on the
  // floor. It is remembered here instead. sessionStorage, not local: a box is one shopping
  // session's intent, and a week-old selection reappearing is worse than the default.
  function saveBox() {
    try { sessionStorage.setItem(BOX_KEY, JSON.stringify({ slots: state.slots, touched: true })); }
    catch (e) {}                    // private mode / storage off: the box just won't survive a reload
  }
  function known(id) { return ORDER.indexOf(id) !== -1; }
  function readBox() {
    try {
      var box = JSON.parse(sessionStorage.getItem(BOX_KEY) || "null");
      if (!box) return null;
      var slots = [];
      if (Array.isArray(box.slots)) {
        // in stock only: a flavour that sold out since the box was saved must not come back as a
        // pick the cart will refuse
        box.slots.forEach(function (id) {
          id = parseInt(id, 10);
          var it = known(id) ? itemOf(id) : null;
          if (it && it.available) slots.push(id);
        });
      } else if (box.qty && typeof box.qty === "object") {
        // a box saved by the stepper builder earlier in this same tab
        ORDER.forEach(function (id) { for (var i = 0; i < (parseInt(box.qty[id], 10) || 0); i++) slots.push(id); });
      }
      return slots.length ? slots.slice(0, MAX) : null;
    } catch (e) { return null; }
  }

  // The box a visitor lands on: the one they built earlier this session, else the default bundle.
  // <div id="ozzi-builder" data-start="one"> opens on the 1-bag card instead (concept homepage).
  function applyDefaultBox() {
    var saved = readBox();
    if (saved) {
      state.slots = saved;
    } else {
      var m = document.getElementById("ozzi-builder");
      state.slots = [];
      state.slots = slotsFor((m && m.dataset.start === "one") ? 1 : DEFAULT_SIZE);
    }
    syncQty();
  }

  // Make the box match a variant -> count map read off the cart. If it is the same box that is on
  // screen, the shopper's own bag order is kept; otherwise the bags are laid out in catalog order.
  function adoptQty(qty) {
    var mine = {}, same = true, k;
    state.slots.forEach(function (id) { mine[id] = (mine[id] || 0) + 1; });
    for (k in qty) if (mine[k] !== qty[k]) same = false;
    for (k in mine) if (qty[k] !== mine[k]) same = false;
    if (same) return;
    var slots = [];
    ORDER.forEach(function (id) { for (var i = 0; i < (qty[id] || 0); i++) slots.push(id); });
    state.slots = slots;
    syncQty();
  }

  // Reflect what's already in the cart: the bundle, the flavours and the frequency follow the
  // matching cart lines. Read-only apart from settleCart(): only the shopper's own buttons write
  // the cart. An EMPTY cart changes nothing here. The box on screen is a proposal until a button
  // is pressed, so emptying the cart in the drawer leaves the cards as they were.
  function primeFromCart() {
    getCart()
      .then(function (cart) {
        var qty = {}, planId = null, total = 0, k;
        var hasSample = false;
        (cart.items || []).forEach(function (line) {
          var id = line.variant_id || line.id;
          if (isGiftLine(line)) return;                         // the promo bottle, not a picked capsule
          if (id === SAMPLE_ID) { hasSample = true; return; }  // the freebie, not a picked item
          if (ORDER.indexOf(id) === -1) return;                // only the builder's own variants
          qty[id] = (qty[id] || 0) + line.quantity;
          if (line.selling_plan_allocation) planId = line.selling_plan_allocation.selling_plan.id;
        });
        for (k in qty) total += qty[k];
        state.sampleInCart = hasSample;
        if (total > 0) {
          adoptQty(qty);
          if (planId && planById(planId)) { state.plan = String(planId); state.freqTouched = true; }
        }
        render();
        // The one exception to "prime never writes": the free items are corrected against
        // what is actually in the cart. It never touches a line the shopper picked.
        settleCart(cart);
      })
      .catch(function () { /* cart unreachable: the default box is already on screen */ });
  }

  // Dawn hands back re-rendered sections on any cart write. The buttons no longer open the drawer
  // (they go to checkout), so these are only for repaintDrawerQuietly(): a correction made on page
  // load still has to show in a drawer the shopper opens from the header.
  var DRAWER_SECTIONS = ["cart-drawer", "cart-icon-bubble"];

  function cartDrawer() {
    var d = document.querySelector("cart-drawer");
    return (d && typeof d.renderContents === "function") ? d : null;
  }

  // Reconcile the live cart to the box, in as few requests as possible. plan is the selling plan
  // id for a subscription commit, null for a one-time one.
  //
  // Pass 1 trims the REAL cart lines toward what the box still wants, one line per request, and
  // picks each next line off the cart that the previous request handed back. That re-read is
  // load-bearing: a line's KEY is not stable. Shopify re-keys a line whenever its discount
  // allocation changes, and a trim that moves the cart across a bundle tier (3 items to 2) does
  // that to every other line. Keys read once and replayed down a chain got a 400 ("no valid id or
  // line parameter") on the second write and left a half-changed cart: one bag switched, the next
  // still on the old plan (found 2026-10-04; the stepper builder had the same chain).
  // Lines are named by key rather than variant id because one variant can occupy two lines (a
  // subscription line and a one-time line of the same flavour) and only the key names one of them.
  // selling_plan is sent even when null, because that is what strips a plan off a line; omitting
  // the field leaves it. On the common path (a fresh visitor, nothing of ours in the cart) this
  // pass makes NO requests.
  //
  // Pass 2 puts the whole shortfall in as ONE add. Neither free item is in it: see settleSample()
  // and settleCart() for why they are added afterwards instead.

  // Read off ONE cart: the first builder line that is not yet right (trim), and what each variant
  // is still short by once every line is (want).
  function commitPlan(cart, plan) {
    var want = {}, trim = null;
    Object.keys(state.qty).forEach(function (id) { want[id] = state.qty[id]; });
    (cart.items || []).forEach(function (line) {
      var id = line.variant_id || line.id;
      if (isGiftLine(line)) return;                         // the promo bottle settles separately
      if (id === SAMPLE_ID) return;                         // the free pack settles separately
      if (ORDER.indexOf(id) === -1) return;                 // not ours, leave it alone
      var cur = line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : null;
      var linePlan = linePlanFor(id, plan);                     // a twin outside the plans goes in once
      var keep = Math.min(line.quantity, want[id] || 0);
      want[id] = (want[id] || 0) - keep;
      if (keep === line.quantity && cur === linePlan) return;   // already correct
      if (!trim) trim = { id: line.key, quantity: keep, selling_plan: linePlan };
    });
    return { trim: trim, want: want };
  }
  // One trim, then plan again from the cart that came back. "left" bounds the walk: a line that
  // will not take a change must not turn the button into a loop, so past the bound the add goes
  // ahead with what is known and checkout shows the cart as it really is.
  function trimCart(cart, plan, left) {
    var p = commitPlan(cart, plan);
    if (!p.trim) return Promise.resolve(p.want);
    if (left <= 0) {
      console.error("[ozzi-builder] cart lines did not settle; adding the rest anyway");
      return Promise.resolve(p.want);
    }
    return cartPost("/cart/change.js", p.trim).then(function (next) { return trimCart(next, plan, left - 1); });
  }
  function commit(cart, plan) {
    return trimCart(cart, plan, (cart.items || []).length + 4).then(function (want) {
      var adds = [];
      Object.keys(want).forEach(function (id) {
        if (want[id] <= 0) return;
        var item = { id: parseInt(id, 10), quantity: want[id] };
        var linePlan = linePlanFor(item.id, plan);
        if (linePlan) item.selling_plan = linePlan;
        adds.push(item);
      });
      // Box only shrank, or already matched: the trims above were the whole job.
      if (!adds.length) return null;
      return cartPost("/cart/add.js", { items: adds })
        .then(function (response) {
          try {
            if (window.OzziOpenAIAds) window.OzziOpenAIAds.added(response, adds);
          } catch (e) {} // Tracking must not change the cart result.
          return response;
        });
    });
  }

  // ONE request that both puts a code on the session and hands back the cart.
  // /discount/<code> normally answers with the entire storefront page purely to set a cookie.
  // ?redirect=/cart.js turns that into a small JSON reply that is exactly the cart read the commit
  // needed next. Falls back to a plain cart read if the redirect is ever refused, which costs
  // correctness nothing: the code is also asserted on page load.
  function primeForCommit() {
    var code = (offer() || {}).code || null;
    if (!code) return getCart();                            // the common case
    return fetch(cartRoot() + "/discount/" + encodeURIComponent(code) + "?redirect=/cart.js",
                 { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .catch(getCart);
  }

  // Both buttons run this: subOn true for "Subscribe & Save", false for "Buy once". The buttons are
  // the only things in this builder that write to the cart, and they go straight to CHECKOUT
  // (Brandon, 2026-10-11). They used to open the cart drawer.
  //
  // The button stays in its loading state until the browser leaves. It is only put back on a
  // failure: if the shopper comes back out of the page cache, snippets/ozzi-checkout reloads the
  // page, and the cards then follow the cart like any other load.
  var committing = false;
  function addToCart(subOn, btn) {
    if (committing || !picked()) return;
    committing = true;
    var cta = document.getElementById("cta"), once = document.getElementById("once");
    cta.disabled = true;
    if (once) once.disabled = true;
    btn.textContent = "Going to checkout…";
    var live = document.getElementById("priceLive");
    if (live) live.textContent = "Going to checkout.";      // both buttons are disabled now: say it here

    function failed(err) {
      committing = false;
      render();                                             // repaints both buttons and re-enables them
      console.error("[ozzi-builder] add to cart failed:", (err && err.message) || err);
      alert("Sorry, something went wrong. Please try again.");
    }
    var plan = subOn ? currentPlan() : null;

    // Leg 1: cart read (plus the first-order code, when there is one, in the same request).
    // Leg 2: the whole box in one write.
    // A failure in either puts the button back with a message: the box is not in the cart.
    primeForCommit()
      .then(function (cart) { return commit(cart, plan); })
      .then(function () {
        // Leg 3: the free items, settled BEFORE leaving. They used to settle behind the open
        // drawer. With no drawer, a free pack or bottle has to be in the cart at $0, or out of it,
        // by the time anyone can pay. On an ordinary cart this is one read and no writes.
        //
        // The box IS in the cart now, so nothing from here on sends the shopper back to the
        // button: a settling step that fails or stalls is logged and they go to checkout anyway,
        // where the site-wide fix-ups (snippets/ozzi-checkout) get their own turn.
        var settled = settleSample()
          .then(getCart)
          .then(function (cart) {
            // The same read then serves those fix-ups, unless the settling just changed it.
            return settleCart(cart).then(function (wrote) { return wrote ? null : cart; });
          });
        return within(SETTLE_MS, settled)
          .catch(function (e) { console.error("[ozzi-builder] settle:", (e && e.message) || e); return null; })
          .then(toCheckout);
      }, failed);
  }
  var SETTLE_MS = 6000;
  // The promise, or null once ms has passed, whichever comes first.
  function within(ms, promise) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { resolve(null); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }
  function toCheckout(cart) {
    if (window.OzziCheckout) { window.OzziCheckout.go(cart); return; }
    // No helper. In the theme editor it is left out on purpose (checkout cannot load inside the
    // preview frame), so the box goes in and the button is simply put back.
    if (window.Shopify && window.Shopify.designMode) { committing = false; render(); notifyCartUI(); return; }
    window.location.href = cartRoot() + "/checkout";        // a layout that does not render it
  }

  // ---------- render ----------
  // The flavour rows only get rebuilt when the NUMBER of bags changes. Changing a flavour just
  // updates values in place, so the dropdown someone is using keeps keyboard focus.
  var OPTIONS = "";
  function renderFlavors() {
    var rows = flavsEl.querySelectorAll(".oz-flav");
    if (rows.length !== state.slots.length) {
      flavsEl.innerHTML = state.slots.map(function (id, i) {
        return '<div class="oz-flav" data-slot="' + i + '">' +
          '<img class="oz-flav-img" alt="" width="40" height="40">' +
          '<select class="oz-select oz-flav-select" data-slot="' + i + '" aria-label="' + CFG.slotAria + " " + (i + 1) + '">' +
            OPTIONS + "</select>" +
          (i >= LAST_SIZE
            ? '<button type="button" class="oz-flav-x" data-remove="' + i + '" aria-label="Remove ' + CFG.noun + " " + (i + 1) + '">×</button>'
            : "") +
        "</div>";
      }).join("");
      rows = flavsEl.querySelectorAll(".oz-flav");
    }
    state.slots.forEach(function (id, i) {
      var row = rows[i], it = itemOf(id);
      if (!row || !it) return;
      var sel = row.querySelector(".oz-flav-select"), img = row.querySelector(".oz-flav-img");
      // a sold-out flavour that is IN the box (it came from the cart) has to stay choosable here
      var opt = sel.querySelector('option[value="' + id + '"]');
      if (opt && opt.disabled) opt.disabled = false;
      if (sel.value !== String(id)) sel.value = String(id);
      if (img.getAttribute("src") !== it.img) img.setAttribute("src", it.img);
    });
  }

  // Pre-order, said where the bag is chosen: when each part of the box ships (Brandon 2026-11-02:
  // "if orders are split between in stock and pre-order, show when each will ship. if they only
  // have pre-order, say it will ship roughly december 1st"). The warehouse sends the in-stock part
  // straight away and holds the pre-order bag, so a mixed box gets one line per part, the in-stock
  // line in the words of the ships-by bar under the button (snippets/ozzi-ship-by: the warehouse's
  // 12:30 PM Central clock, read off the bar so the rule lives in one place). A box of nothing but
  // pre-order bags ships around PREORDER_SHIP, and the bar says that too instead of "Ships Today".
  function joinNames(names) {
    return names.length > 1 ? names.slice(0, -1).join(", ") + " and " + names[names.length - 1] : names[0];
  }
  function shipBarText() {
    return document.querySelector("#ozzi-builder .ozzi-shipby .oz-sb-text");
  }
  // "Ships Today" -> "Ships today", "Ships by Monday" stays. preview.html has no bar (no Liquid).
  function shipNowLabel() {
    var el = shipBarText();
    var t = el && !el.hasAttribute("data-oz-pre") ? el.textContent.replace(/\s+/g, " ").trim() : "";
    if (!/^Ships /.test(t)) return "Ships right away";
    return t.replace(/ (Today|Tomorrow)$/, function (m) { return m.toLowerCase(); });
  }
  function paintShipBar(allPre) {
    var el = shipBarText();
    if (!el) return;
    var on = el.hasAttribute("data-oz-pre");
    if (allPre && !on) {
      el.setAttribute("data-oz-pre", el.innerHTML);         // the clock's words, put back below
      el.setAttribute("data-fixed", "");                    // the bar's own timer skips data-fixed
      el.innerHTML = "Ships <b>~" + PREORDER_SHIP + "</b>";
    } else if (!allPre && on) {
      el.innerHTML = el.getAttribute("data-oz-pre");
      el.removeAttribute("data-oz-pre");
      el.removeAttribute("data-fixed");                     // its next tick brings it up to the minute
    }
  }
  function renderPreNote() {
    var el = document.getElementById("preNote");
    var pre = [], now = [], once = false;
    state.slots.forEach(function (id) {
      var it = itemOf(id);
      if (!it) return;
      var list = it.twinOf ? pre : now;
      if (list.indexOf(it.name) === -1) list.push(it.name);
      if (it.twinOf && !subscribable(it)) once = true;
    });
    var allPre = pre.length > 0 && !now.length;
    paintShipBar(allPre);
    if (!el) return;                                        // markup cached from before 2026-10-23
    el.hidden = !pre.length;
    if (!pre.length) { el.textContent = ""; return; }
    // A mixed box on Subscribe & Save: its first refill waits for the pre-order bag. ozzi-reviews'
    // hourly /api/cron/preorder-renewals moves the Skio renewal to PREORDER_SHIP + the cycle
    // (Brandon 2026-11-02), so the shopper is told before they pay.
    var cycle = cadence(freqEl.value).replace(/^every /, "");
    if (!/\d/.test(cycle)) cycle = "one delivery cycle";
    el.innerHTML = (allPre
      ? "<b>Pre-order:</b> your order ships around " + PREORDER_SHIP + "."
      : "<b>" + shipNowLabel() + ":</b> " + joinNames(now) +
        "<br><b>Ships around " + PREORDER_SHIP + ":</b> " + joinNames(pre) + " (pre-order)") +
      (once ? "<br>Pre-order bags are billed once, not as part of a subscription." : "") +
      (allPre ? "" : "<br>Subscription refills start " + cycle + " after " + PREORDER_SHIP + ".");
  }
  // The in-stock line follows the bar across the 12:30 PM cutoff on a page left open.
  setInterval(function () {
    var el = document.getElementById("preNote");
    if (el && !el.hidden) renderPreNote();
  }, 60000);

  function render() {
    var n = picked();
    var active = activeSize(n);
    var plan = planFor(n);
    if (plan && freqEl.value !== plan) freqEl.value = plan;
    var showPromo = FOCUS === "drinks" && promoShown();

    var q = null;                                           // the box on screen, subscribed
    SIZES.forEach(function (sz) {
      var el = cardOf(sz.size);
      if (!el) return;
      var on = sz.size === active;
      var slots = on ? state.slots : slotsFor(sz.size);
      var planId = on ? plan : planFor(slots.length);
      var short = slots.length < sz.size;                   // not enough in stock to fill this card
      var cq = quoteSlots(slots, true, planId);
      if (on) q = cq;
      el.dataset.active = on;
      el.dataset.off = short;
      var radio = el.querySelector(".oz-bundle-radio");
      radio.checked = on;
      radio.disabled = short;
      el.querySelector(".oz-bundle-name").textContent = short
        ? sz.size + " " + (sz.size === 1 ? CFG.Noun : CFG.NounPl)
        : nameFor(slots);
      el.querySelector(".oz-bundle-sub").textContent = short
        ? "Sold out"
        : describeSlots(slots) + ", delivered " + cadence(planId);
      var per = slots.length ? cq.pay / slots.length : 0;
      el.querySelector(".oz-bundle-price strong").innerHTML = short ? "" :
        money(per) + '<span class="oz-bundle-unit">' + unitFor(slots) + "</span>";
      var was = slots.length ? cq.retail / slots.length : 0;
      var struck = !short && cq.pctOff >= 1;
      el.querySelector(".oz-bundle-price s").textContent = struck ? money(was) : "";
      el.querySelector(".oz-bundle-was").hidden = !struck;   // read aloud, so the struck price is not just a second number
      // One savings number per card: the whole saving as a percentage of retail, after the
      // subscription, the bundle and any first-order code. The dollars are in the open card.
      var bits = [];
      if (sz.badge) bits.push(sz.badge);
      if (!short && cq.pctOff >= 1) bits.push(cq.pctOff + "% off");
      if (!short && showPromo && contentsOf(slots).bags >= PROMO.buyBags) bits.push("Free Capsules");
      el.querySelector(".oz-bundle-badge").textContent = bits.join(" · ");
      // The one flavour panel lives in whichever card is selected. Moving the node (rather than
      // rebuilding it) keeps the dropdowns, their focus and an open waitlist form intact.
      if (on && panelEl.parentNode !== el) el.appendChild(panelEl);
    });
    panelEl.hidden = !active;
    renderBanner();

    var cta = document.getElementById("cta");
    var once = document.getElementById("once");
    var giftFree = !!(SAMPLE_ON && state.sampleLive && giftShown());
    if (!active || !q) {
      // nothing buyable at all
      renderGift(false);
      if (!committing) { cta.disabled = true; cta.textContent = "Sold out"; }
      if (once) once.hidden = true;
      return;
    }

    renderFlavors();
    var label = document.getElementById("flavLabel");
    if (label) label.textContent = CFG.pickLabel;
    var more = document.getElementById("more");
    if (more) {
      more.hidden = !(active === LAST_SIZE && n < MAX && pool().length);
      more.textContent = "+ Add another " + CFG.noun;
    }
    renderBoxImages(n);
    var lock = document.getElementById("perkLock");
    var perks = document.querySelector("#ozzi-builder .oz-perks");
    if (LADDER && perks) {
      // A first-order code only cuts the first box, so it is added back: "for life" is what every refill saves.
      var ld = LADDER(n, pctUp(q.retail, q.pay + q.codeCut));
      // Brandon 2026-10-28: "move the % off for life, and free shipping callout above right now so that's the day-1
      // sale", and "move the bonus gifts on future orders down to an expandable section below". So: what the first
      // box gets, above the delivery picker; the later-order gifts closed under the perk lines, above the savings.
      var deliver = document.querySelector("#ozzi-builder .oz-deliver");
      var day1 = document.getElementById("ozDay1");
      if (!day1) {
        day1 = document.createElement("div");
        day1.id = "ozDay1";
        day1.className = "oz-day1";
      }
      day1.textContent = "";
      var dh = document.createElement("p");
      dh.className = "oz-gifts-h";
      dh.textContent = "Starting today";
      day1.appendChild(dh);
      day1.appendChild(tileRow(ld.today));
      if (deliver && day1.nextSibling !== deliver) deliver.parentNode.insertBefore(day1, deliver);
      perks.textContent = "";
      ld.lines.forEach(function (t) { var li = document.createElement("li"); li.textContent = t; perks.appendChild(li); });
      // The same <details> is kept between renders, so it stays open or closed as the shopper left it.
      var gifts = document.getElementById("ozGifts");
      if (!gifts) {
        gifts = document.createElement("details");
        gifts.id = "ozGifts";
        gifts.className = "oz-gifts";
      }
      gifts.textContent = "";
      var gh = document.createElement("summary");
      gh.textContent = "Bonus gifts on future orders";
      var body = document.createElement("div");
      body.className = "oz-gifts-body";
      body.appendChild(tileRow(ld.gifts));
      gifts.appendChild(gh);
      gifts.appendChild(body);
      if (perks.nextSibling !== gifts) perks.parentNode.insertBefore(gifts, perks.nextSibling);
      lock = null;
    }
    if (lock) {
      if (offer().code) {
        // A first-order code is in every price on screen, so the price a refill bills at would
        // otherwise appear nowhere. Named here, whatever the size of the box.
        var renews = state.slots.filter(function (id) { var it = itemOf(id); return it && subscribable(it); });
        var rq = renews.length === state.slots.length ? q : quoteSlots(renews, true, plan);
        var refill = rq.pay + rq.codeCut;
        lock.hidden = false;
        lock.textContent = "Refills at " + money(refill) + (n > 1 ? ", bundle price locked in" : "");
      } else {
        lock.hidden = n < 2;                                // one bag has no bundle price to lock in
        lock.textContent = "Locked-in bundle price on every refill";
      }
    }

    renderPreNote();

    var saved = q.retail - q.pay;
    var hasSavings = saved > 0.005;
    var savings = document.getElementById("savings");
    savings.hidden = !hasSavings;
    document.getElementById("savedLine").textContent = hasSavings
      ? "You save " + money(saved) + (offer().code ? " on your first order" : "")
      : "";
    renderLedger(q, n, state.slots, giftFree);
    renderGift(giftFree);

    if (!committing) {
      cta.disabled = false;
      // The main button is the subscription, and says so. It names the price so the choice between
      // it and "Buy once" underneath is two numbers side by side, nothing to work out.
      cta.innerHTML = '<span class="oz-cta-label">Subscribe &amp; Save</span>' +
        '<span class="oz-cta-price">' + money(q.pay) + (hasSavings ? " <s>" + money(q.retail) + "</s>" : "") + "</span>";
      if (once) {
        // The same box, bought once: the bundle discount still applies, the subscription's cut does not.
        var o1 = quoteSlots(state.slots, false, plan);
        once.hidden = false;
        once.disabled = false;
        // One number is not enough to choose on. Under the free-shipping line a one-time order pays
        // shipping, so say so; over it, give the per-bag price to set against the card's.
        var note = o1.pay < FREE_SHIP_MIN ? "+ shipping"
          : (n > 1 ? "(" + money(o1.pay / n) + unitFor(state.slots) + ")" : "");
        once.innerHTML = "Buy once for " + money(o1.pay) +
          (note ? ' <span class="oz-once-note">' + note + "</span>" : "");
      }
      var live = document.getElementById("priceLive");
      if (live) {
        var said = "Subscribe and save: " + money(q.pay) + ". " + (once ? once.textContent.replace(/\s+/g, " ") + "." : "");
        if (live.textContent !== said) live.textContent = said;
      }
    }

    var _mNew = document.getElementById("mNew");
    var _mStd = document.getElementById("mStd");
    var _srcTag = document.getElementById("srcTag");
    if (_mNew) _mNew.setAttribute("aria-pressed", state.mode === "newcust");
    if (_mStd) _mStd.setAttribute("aria-pressed", state.mode === "standard");
    if (_srcTag) {
      _srcTag.textContent = LIVE ? "catalog rendered by Shopify Liquid" : "sample catalog (no Liquid in preview)";
      _srcTag.dataset.live = LIVE;
    }
  }

  // A flavour priced under its compare-at gets its own line, named for the flavour. It is that
  // one bag's markdown and nothing wider: a sale name here read as a discount on every bag.
  function markdownRows(slots) {
    var by = {}, order = [];
    slots.forEach(function (id) {
      var it = itemOf(id);
      if (!it || it.compareAt - it.price <= 0.005) return;
      if (!by[it.id]) { by[it.id] = { name: it.name, off: it.compareAt - it.price, n: 0 }; order.push(it.id); }
      by[it.id].n += 1;
    });
    return order.map(function (id) {
      var m = by[id];
      var each = cents(m.off) % 100 === 0 ? money0(m.off) : money(m.off);
      return '<div class="oz-lrow oz-cut"><span class="oz-l">' + m.name + ", " + each + " off" +
        (m.n > 1 ? " each" : "") + '</span><span class="oz-r">−' + money(m.off * m.n) + "</span></div>";
    });
  }

  // Every discount on its own line, so the price is legible rather than just low. The breakdown
  // foots from retail down to what they pay, using product discounts only. Free shipping and free
  // items are listed as bonuses with no dollar value, so they read as things they get rather than
  // as discount the maths has to justify.
  function renderLedger(q, n, slots, giftFree) {
    var o = offer();
    var c = contentsOf(slots);
    var what = c.bags && c.bottles ? n + " items" : n + " " + (c.bottles ? (n === 1 ? "bottle" : "bottles") : (n === 1 ? "bag" : "bags"));
    var rows = [];
    rows.push('<div class="oz-lrow oz-retail"><span class="oz-l">Retail, ' + what +
      '</span><span class="oz-r">' + money(q.retail) + "</span></div>");
    rows = rows.concat(markdownRows(slots));
    // Subscribe before Bundle: the plan's cut comes off the unit price, then the per-bag dollars
    // come off that. Same order the cart applies them.
    if (q.subCut > 0.005) {
      rows.push('<div class="oz-lrow oz-cut"><span class="oz-l">Subscribe &amp; Save ' + subPctText() +
        '</span><span class="oz-r">−' + money(q.subCut) + "</span></div>");
    }
    if (q.bundleCut > 0.005) {
      rows.push('<div class="oz-lrow oz-cut"><span class="oz-l">Bundle, $' + perBagOff(n) +
        ' off each</span><span class="oz-r">−' + money(q.bundleCut) + "</span></div>");
    }
    if (q.codeCut > 0.005) {
      rows.push('<div class="oz-lrow oz-cut"><span class="oz-l">First order <span class="oz-code-chip">' + o.code +
        '</span></span><span class="oz-r">−' + money(q.codeCut) + "</span></div>");
    }
    rows.push('<div class="oz-lrow oz-bonus"><span class="oz-l">Shipping</span>' +
      '<span class="oz-r">FREE</span></div>');
    if (giftFree) {
      rows.push('<div class="oz-lrow oz-bonus"><span class="oz-l">Sample pack, ' + SAMPLE_STICKS +
        ' sticks</span><span class="oz-r">FREE</span></div>');
    }
    // Same rule for a promo bottle: listed, never valued into "You save".
    if (giftEarned()) {
      rows.push('<div class="oz-lrow oz-bonus"><span class="oz-l">Crave Crusher Capsules, 1 bottle</span>' +
        '<span class="oz-r">FREE</span></div>');
    }
    if (SAMPLE_ON) {
      rows.push('<div class="oz-lrow oz-bonus"><span class="oz-l">Credit on your 2nd order</span>' +
        '<span class="oz-r">' + money0(secondOrderCredit(n)) + " off</span></div>");
    }
    rows.push('<div class="oz-lrow oz-due"><span class="oz-l">Today</span>' +
      '<span class="oz-r">' + money(q.pay) + "</span></div>");
    document.getElementById("ledger").innerHTML = rows.join("");
  }

  // Sample landers lead with the pack shot instead of the generic tick. Null-guarded because the
  // markup ships in the Liquid snippet while the JS is a separate asset, so a cached page can pair
  // old markup with new JS.
  // photoSrc swaps the sample's transparent cutout for a square photo (the capsules bottle), which
  // carries its own background and so gets a rounded tile rather than sitting loose on the green.
  function bannerArt(useImage, photoSrc) {
    var tick = document.getElementById("bannerTick");
    var img = document.getElementById("bannerImg");
    if (tick) tick.hidden = useImage;
    if (!img) return;
    img.hidden = !useImage;
    if (photoSrc) {
      if (!img.dataset.cutout) img.dataset.cutout = img.getAttribute("src") || "";
      if (img.getAttribute("src") !== photoSrc) img.setAttribute("src", photoSrc);
      img.classList.add("is-photo");
    } else if (img.dataset.cutout) {
      img.setAttribute("src", img.dataset.cutout);
      img.classList.remove("is-photo");
    }
  }
  function renderBanner() {
    var el = document.getElementById("banner");
    if (!el) return;
    var o = offer();
    // A promo takes the banner while it runs. On a page that also carries a first-order code the
    // code still gets named, as the second line, so neither offer is hidden behind the other.
    if (promoShown()) {
      el.dataset.on = true;
      bannerArt(!!GIFT.image, GIFT.image || null);
      document.getElementById("bannerTitle").textContent = "Buy 2 bags, get Capsules free";
      document.getElementById("bannerSub").textContent = o.code
        ? " Plus " + o.code + " is applied: an extra " + Math.round(o.pct * 100) + "% off your first order."
        : " A 28-day bottle of Crave Crusher Capsules, free with your order.";
      return;
    }
    // Sample lander: the pack is the incentive, so it takes the banner slot up top. Scratch mode
    // owns the gift message in its own panel, so the banner is left to the offer code below.
    if (SAMPLE_ON && GIFT_MODE !== "scratch") {
      el.dataset.on = true;
      bannerArt(true);
      document.getElementById("bannerTitle").textContent = "Free Sample Pack included";
      document.getElementById("bannerSub").textContent =
        " 5 sticks, one of every flavor, free with any bag.";
      return;
    }
    bannerArt(false);
    el.dataset.on = !!o.code;
    if (!o.code) return;
    document.getElementById("bannerTitle").textContent =
      o.code + " applied: an extra " + Math.round(o.pct * 100) + "% off";
    document.getElementById("bannerSub").textContent =
      " your first order. The prices below include it.";
  }

  // ---------- init ----------
  // The embed sets the offer once:
  //   <div id="ozzi-builder" data-offer-code="CRUSH15" data-offer-pct="15">
  // Standard PDP omits both attributes.
  var mount = document.getElementById("ozzi-builder");
  if (SAMPLE_ON) {
    // The free pack IS the offer here. Auto-applying SAMPLE replaces whatever code is on the
    // session and it doesn't combine with order discounts, so pricing a code in would quote a
    // number the cart will never honour.
    state.mode = "standard";
  } else if (mount && mount.dataset.offerCode) {
    OFFERS.newcust.code = mount.dataset.offerCode;
    OFFERS.newcust.pct = (parseFloat(mount.dataset.offerPct) || 15) / 100;
    state.mode = "newcust";
  } else if (mount) {
    state.mode = "standard";
  }

  var res = readCatalog();
  CATALOG = res.data;
  PLANS = res.plans;
  LIVE = res.live;
  if (res.subPct) SUB_PCT = res.subPct;
  if (res.sample && res.sample.price) SAMPLE_VALUE = res.sample.price / 100;
  GIFT = readGift(res);

  // h1 only, on purpose: an embed that passes its own heading passes a heading_level with it, and
  // Liquid has already written that text. This only fills in the default heading.
  var _h = document.querySelector("#ozzi-builder .oz-heading h1");
  if (_h) _h.textContent = CFG.heading;
  buildItems();
  OPTIONS = optionsHtml();
  buildBundles();
  buildPlans();
  buildOos();
  buildScratch();
  wire();
  // The default bundle is on screen straight away; the cart is read next and, if it already holds
  // some of ours, the cards switch to match it (read-only prime; see primeFromCart).
  applyDefaultBox();
  render();
  primeFromCart();
  applyOfferCode();   // put the priced-in first-order code (CRUSH15) on the session on arrival
  // Reflect external cart changes too (e.g. removing an item in the pop-up drawer), not just
  // the load-time snapshot. Ignore our own writes so this can't loop. Read-only like prime, apart
  // from settleCart() keeping the free items in step (its writes publish nothing, so no loop).
  try {
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === "ozzi-builder") return;
        primeFromCart();
      });
    }
  } catch (e) {}
})();
